export enum ColorSchemaEnum {
    DEFAULT = 'default',
    LIGHT = 'light',
    DARK = 'dark',
}
